import { render, staticRenderFns } from "./WelfareMallSettings.vue?vue&type=template&id=3e842507&scoped=true"
import script from "./WelfareMallSettings.vue?vue&type=script&lang=js"
export * from "./WelfareMallSettings.vue?vue&type=script&lang=js"
import style0 from "./WelfareMallSettings.vue?vue&type=style&index=0&id=3e842507&prod&lang=less"
import style1 from "./WelfareMallSettings.vue?vue&type=style&index=1&id=3e842507&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e842507",
  null
  
)

export default component.exports